import { Link, useParams } from 'react-router-dom';
import { WORKSPACE_HEADER_HEIGHT } from './workspace-header';
import { WhoopSidebar } from './whoop-sidebar';
import { coerceWhoopPage, C } from './whoop-theme';
import { NowPage } from './whoop-pages/now-page';
import { PlanPage } from './whoop-pages/plan-page';
import { ProgressPage } from './whoop-pages/progress-page';
import { BuilderPage } from './whoop-pages/builder-page';
import { TrendsPage } from './whoop-pages/trends-page';
import { ExperimentsPage } from './whoop-pages/experiments-page';
import { WhoopSettingsPage } from './whoop-pages/settings-page';
import './whoop.css';

/**
 * Full-height shell for the WHOOP workspace: the hover-expand rail and a
 * scrolling content column. The active page comes from the `:page` route
 * segment, coerced to a known page (unknown segments fall back to "now").
 */
export function WhoopWorkspacePage() {
  const params = useParams();
  const page = coerceWhoopPage(params.page);

  return (
    <div
      // The global header sits above us in RootLayout; the rail and content
      // column own the rest of the viewport with no page-level scroll.
      style={{
        height: `calc(100vh - ${WORKSPACE_HEADER_HEIGHT}px)`,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <div className="ws-row">
        <WhoopSidebar currentPage={page} />
        <main style={{ flex: 1, minWidth: 0, overflowY: 'auto', background: C.bg }}>
          <div style={{ maxWidth: 1080, margin: '0 auto', padding: '30px 40px 90px' }}>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                fontSize: 12,
                color: C.text3,
                fontFamily: "'JetBrains Mono',monospace",
                marginBottom: 6,
              }}
            >
              <Link to="/integrations" style={{ cursor: 'pointer' }}>
                integrations
              </Link>
              <span>/</span>
              <span style={{ color: C.accent }}>whoop</span>
              <span>/</span>
              <span style={{ color: C.text2 }}>{page}</span>
            </div>

            <div key={page} className="ww-fade-in">
              {page === 'now' && <NowPage />}
              {page === 'plan' && <PlanPage />}
              {page === 'progress' && <ProgressPage />}
              {page === 'builder' && <BuilderPage />}
              {page === 'trends' && <TrendsPage />}
              {page === 'experiments' && <ExperimentsPage />}
              {page === 'settings' && <WhoopSettingsPage />}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
